import { configureStore } from "@reduxjs/toolkit";
import booksReducer from "./redux/reducers/booksSlice";
import chaptersReducer from "./redux/reducers/chaptersSlice";

const store = configureStore({
  reducer: {
    books: booksReducer,
    chapters: chaptersReducer,
  },
});

export default store;
